export default "  // empty\n";